import React from 'react';
import './index.css';
import { render } from 'react-dom';
import posthog from 'posthog-js';
import { App } from './App';
posthog.init('phc_yISew0Fo0iFivgZseY4EZ91pHM2vsfgmnd02sI69J5', {
  api_host: 'https://us.i.posthog.com',
  defaults: '2026-01-30'
});
render(<App data-id="element-91" data-mp="21cadbz1qtvd5" />, document.getElementById('root'));